import { Navigate } from 'react-router';
import { useAuth } from '@/hooks/useAuth';
import { LoginForm } from '@/components/features/auth/LoginForm';

export function Login() {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user) {
    const redirectPath = user.role === 'doctor' ? '/doctor' : '/patient';
    return <Navigate to={redirectPath} replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-primary-50 via-background to-secondary-50 p-4">
      <LoginForm />
    </div>
  );
}
